import React, { useEffect, useState } from 'react';

const Accompagnements = () => {
  const [scrollY, setScrollY] = useState(0);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-champagne relative overflow-hidden">
      {/* Particules Quantiques Optimisées Mobile */}
      <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
        {/* Particules dorées - réduites sur mobile */}
        {[...Array(15)].map((_, i) => (
          <div
            key={`quantum-${i}`}
            className="absolute animate-particle-float hidden sm:block"
            style={{
              left: `${Math.random() * 100}%`,
              width: `${3 + Math.random() * 4}px`,
              height: `${3 + Math.random() * 4}px`,
              animationDelay: `${i * 0.8}s`,
              animationDuration: `${10 + Math.random() * 8}s`
            }}
          >
            <div className="w-full h-full rounded-full bg-gradient-to-br from-gold via-yellow-400 to-gold shadow-lg" style={{boxShadow: '0 0 12px rgba(201,169,97,0.7)'}} />
            <div className="absolute inset-0 -m-1 rounded-full border border-gold/40 animate-pulse-slow" />
          </div>
        ))}
        
        {/* Lignes de connexion - masquées sur mobile */}
        {[...Array(5)].map((_, i) => (
          <div
            key={`line-${i}`}
            className="absolute h-px bg-gradient-to-r from-transparent via-gold/20 to-transparent animate-shimmer-fast hidden md:block"
            style={{
              top: `${15 + i * 15}%`,
              left: '0',
              right: '0',
              animationDelay: `${i * 0.5}s`,
            }}
          />
        ))}
        
        {/* Bulles dorées - adaptées mobile */}
        <div 
          className="absolute w-48 h-48 md:w-96 md:h-96 rounded-full bg-gradient-to-br from-gold/15 to-transparent blur-2xl md:blur-3xl animate-float"
          style={{ top: '10%', left: '5%' }}
        />
        <div 
          className="absolute w-32 h-32 md:w-64 md:h-64 rounded-full bg-gradient-to-br from-brown-warm/15 to-transparent blur-xl md:blur-2xl animate-float-delayed"
          style={{ top: '60%', right: '10%' }}
        />
      </div>

      {/* Navigation Responsive avec Hamburger */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-brown-warm/98 backdrop-blur-xl shadow-xl">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 py-3 md:py-5 flex items-center justify-between">
          <img 
            src="https://gillesdelieuze.com/wp-content/uploads/2022/12/Logo_Final_3bd-.png" 
            alt="Gilles Delieuze" 
            className="h-8 sm:h-10 md:h-12 transform hover:scale-110 transition-transform duration-500" 
          />
          
          {/* Menu Desktop */}
          <div className="hidden lg:flex items-center gap-6 xl:gap-10">
            <a href="https://gillesdelieuze.com/formations/" className="text-xs tracking-[0.15em] md:tracking-[0.2em] text-champagne hover:text-gold transition-all duration-300 transform hover:scale-110 uppercase font-light">FORMATIONS</a>
            <a href="https://gillesdelieuze.com/voyages-2/" className="text-xs tracking-[0.15em] md:tracking-[0.2em] text-champagne hover:text-gold transition-all duration-300 transform hover:scale-110 uppercase font-light">VOYAGES</a>
            <a href="https://gillesdelieuze.com/accompagnements-11/" className="text-xs tracking-[0.15em] md:tracking-[0.2em] text-champagne hover:text-gold transition-all duration-300 transform hover:scale-110 uppercase font-light">MENTORAT</a>
            <a href="https://gillesdelieuze.com/a-propos/" className="text-xs tracking-[0.15em] md:tracking-[0.2em] text-champagne hover:text-gold transition-all duration-300 transform hover:scale-110 uppercase font-light">À PROPOS</a>
            <a href="https://gillesdelieuze.com/login/" className="text-xs tracking-[0.15em] md:tracking-[0.2em] text-gold italic font-light hover:scale-110 transition-transform cursor-pointer">Log in</a>
          </div>
          
          {/* Hamburger Mobile */}
          <button 
            className="lg:hidden text-champagne p-2 hover:text-gold transition-colors"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Menu"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {mobileMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>
        
        {/* Menu Mobile Dropdown */}
        {mobileMenuOpen && (
          <div className="lg:hidden bg-brown-warm/98 backdrop-blur-xl border-t border-gold/20 animate-fade-in">
            <div className="px-4 py-6 space-y-4">
              <a href="https://gillesdelieuze.com/formations/" className="block text-sm tracking-[0.15em] text-champagne hover:text-gold transition-colors uppercase font-light py-2">FORMATIONS</a>
              <a href="https://gillesdelieuze.com/voyages-2/" className="block text-sm tracking-[0.15em] text-champagne hover:text-gold transition-colors uppercase font-light py-2">VOYAGES</a>
              <a href="https://gillesdelieuze.com/accompagnements-11/" className="block text-sm tracking-[0.15em] text-champagne hover:text-gold transition-colors uppercase font-light py-2">MENTORAT</a>
              <a href="https://gillesdelieuze.com/a-propos/" className="block text-sm tracking-[0.15em] text-champagne hover:text-gold transition-colors uppercase font-light py-2">À PROPOS</a>
              <a href="https://gillesdelieuze.com/login/" className="block text-sm tracking-[0.15em] text-gold italic font-light py-2">Log in</a>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Ultra Responsive */}
      <section className="relative min-h-screen flex items-center pt-16 sm:pt-20 md:pt-24 bg-gradient-to-br from-champagne via-beige-warm to-champagne">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 w-full py-12 md:py-20 relative z-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12 md:gap-20 items-center">
            <div className="space-y-4 sm:space-y-6 md:space-y-8 animate-fade-in-up text-center md:text-left">
              <div>
                <span className="inline-block text-[0.65rem] sm:text-xs tracking-[0.3em] sm:tracking-[0.4em] text-brown-warm uppercase font-semibold px-4 sm:px-6 py-1.5 sm:py-2 rounded-full border-2 border-gold/60 bg-gold/20 hover:bg-gold/30 transition-all duration-500 transform hover:scale-105 shadow-lg">
                  ACCOMPAGNEMENT
                </span>
              </div>
              
              <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-9xl font-serif font-light text-brown-warm leading-none transform hover:scale-105 transition-transform duration-700 relative">
                <span className="relative inline-block">
                  Individuel
                  <span className="absolute inset-0 text-gold opacity-0 hover:opacity-30 blur-xl transition-opacity duration-500">Individuel</span>
                </span>
              </h1>
              
              <div className="relative">
                <p className="text-xl sm:text-2xl md:text-3xl text-gold font-light mb-4 sm:mb-6" style={{ fontFamily: 'Georgia, serif' }}>
                  L'Expression de ta <span className="italic">Pleine Lumière</span>
                </p>
                <div className="w-24 sm:w-32 h-1 bg-gradient-to-r from-gold via-yellow-600 to-transparent animate-shimmer-fast mx-auto md:mx-0" />
              </div>
              
              <p className="text-base sm:text-lg md:text-xl text-brown-warm/80 leading-relaxed font-light max-w-xl mx-auto md:mx-0">
                Un voyage vers soi, une expansion profonde, une révélation de ton essence.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 pt-4 sm:pt-6 justify-center md:justify-start">
                <a href="#formules" className="group bg-brown-dark hover:bg-brown-warm text-champagne px-8 sm:px-12 py-5 sm:py-7 rounded-full text-xs sm:text-sm tracking-[0.15em] uppercase font-bold transform hover:scale-110 transition-all duration-500 border-2 border-gold shadow-2xl inline-block text-center">
                  <span className="group-hover:tracking-[0.2em] transition-all duration-300">DÉCOUVRIR</span>
                </a>
                <a href="#apropos" className="border-3 border-brown-dark bg-white/90 text-brown-dark hover:bg-gold hover:text-white hover:border-gold hover:shadow-2xl px-8 sm:px-12 py-5 sm:py-7 rounded-full text-xs sm:text-sm tracking-[0.15em] uppercase font-bold transform hover:scale-110 transition-all duration-500 shadow-lg inline-block text-center">
                  EN SAVOIR PLUS
                </a>
              </div>
            </div>

            <div className="relative animate-fade-in-up animation-delay-400 max-w-sm mx-auto md:max-w-none">
              {/* Cercle Décoratif Animé */}
              <div className="absolute -inset-6 sm:-inset-8 bg-gradient-to-br from-gold/25 to-transparent rounded-full blur-2xl md:blur-3xl animate-pulse-slow" />
              
              {/* Photo en Cercle avec Border Animé Ultra-Dynamique */}
              <div className="relative group">
                {/* Triple bordure rotative */}
                <div className="absolute -inset-0.5 sm:-inset-1 rounded-full bg-gradient-to-r from-gold via-yellow-500 to-gold bg-size-200 animate-gradient-fast opacity-90 blur-sm" />
                <div className="absolute -inset-1 sm:-inset-2 rounded-full bg-gradient-to-br from-gold/40 via-transparent to-gold/40 animate-spin-slow" />
                <div className="absolute -inset-1.5 sm:-inset-3 rounded-full bg-gradient-to-tl from-yellow-600/30 via-transparent to-gold/30 animate-spin-reverse" />
                
                <div className="relative rounded-full overflow-hidden border-4 sm:border-[6px] border-champagne shadow-2xl transform group-hover:scale-110 group-hover:rotate-6 transition-all duration-700">
                  <img
                    src="https://gillesdelieuze.com/wp-content/uploads/2024/03/IMG_9881_www.vincentphotographie.com_-683x1024.jpg"
                    alt="Gilles Delieuze"
                    className="w-full h-full object-cover aspect-square transform group-hover:scale-110 transition-transform duration-1000"
                  />
                  {/* Overlay glow au hover */}
                  <div className="absolute inset-0 bg-gradient-to-br from-gold/20 via-transparent to-gold/20 opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section Dynamique - Et si tout était là */}
      <section className="relative py-16 sm:py-24 md:py-32 px-4 sm:px-6 md:px-8 bg-brown-dark text-champagne overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_rgba(201,169,97,0.1)_0%,_transparent_70%)] animate-pulse-slow" />
        
        <div className="relative max-w-5xl mx-auto text-center z-10">
          <div className="mb-12 sm:mb-16 md:mb-20 transform hover:scale-105 transition-transform duration-700">
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-serif font-light mb-6 sm:mb-8 leading-tight px-2">
              Et si tout était <span className="italic text-gold animate-glow">déjà là</span> ?
            </h2>
            <div className="w-32 sm:w-40 h-1 bg-gradient-to-r from-transparent via-gold to-transparent mx-auto animate-shimmer-fast" />
          </div>
          
          <div className="space-y-6 sm:space-y-8 md:space-y-10 text-base sm:text-lg md:text-xl leading-relaxed font-light px-2">
            <p className="text-xl sm:text-2xl md:text-3xl italic text-gold transform hover:scale-105 transition-transform duration-500">
              Ce feu sacré en toi.
            </p>
            
            <p className="text-lg sm:text-xl md:text-2xl hover:text-gold/90 transition-colors duration-500">
              Cet élan d'être plus, de t'aligner, de rayonner, de manifester pleinement ta puissance intérieure.
            </p>
            
            <p className="text-sm sm:text-base md:text-lg text-champagne/70">
              Tu le ressens, il vibre en toi… mais il y a encore ces voiles invisibles.
            </p>
          </div>
        </div>
      </section>

      {/* 3 Cercles Flottants - Responsive */}
      <section className="py-16 sm:py-24 md:py-32 px-4 sm:px-6 md:px-8 bg-beige-warm relative overflow-hidden">
        {/* Particules quantiques - masquées sur mobile */}
        <div className="absolute inset-0 overflow-hidden opacity-30 hidden sm:block">
          {[...Array(15)].map((_, i) => (
            <div
              key={`particle-${i}`}
              className="absolute rounded-full bg-gradient-to-br from-gold to-yellow-500 animate-particle-float"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                width: `${2 + Math.random() * 3}px`,
                height: `${2 + Math.random() * 3}px`,
                animationDelay: `${i * 1.2}s`,
                animationDuration: `${10 + Math.random() * 8}s`
              }}
            />
          ))}
        </div>
        
        <div className="max-w-7xl mx-auto relative z-10">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-12 md:gap-16">
            {[
              {
                icon: "dna",
                title: "Lignées",
                text: "Ces mémoires sont parfois celles de nos lignées, des non-dits familiaux, des blessures non résolues."
              },
              {
                icon: "infinity",
                title: "Vies Antérieures",
                text: "D'autres viennent de vies antérieures, de promesses inconscientes, d'expériences passées."
              },
              {
                icon: "stars",
                title: "Cette Vie",
                text: "Et puis, il y a les empreintes de cette vie, les conditionnements sociaux, les blessures émotionnelles."
              }
            ].map((item, i) => (
              <div key={i} className="group relative transform hover:-translate-y-4 transition-all duration-700">
                {/* Cercle Glow */}
                <div className="absolute -inset-3 sm:-inset-4 bg-gradient-to-br from-gold/20 to-transparent rounded-full blur-xl sm:blur-2xl group-hover:blur-3xl transition-all duration-700" />
                
                <div className="relative bg-white rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-10 shadow-xl hover:shadow-2xl transition-all duration-500 border-2 border-gold/20 group-hover:border-gold/60">
                  {/* Icône 3D CSS doré */}
                  <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-gradient-to-br from-gold to-yellow-600 flex items-center justify-center mb-6 sm:mb-8 shadow-lg group-hover:rotate-[360deg] group-hover:scale-110 transition-all duration-1000">
                    <div className={`icon-${item.icon} text-white`}></div>
                  </div>
                  <h3 className="text-xl sm:text-2xl font-serif font-light text-brown-warm mb-4 sm:mb-6 group-hover:text-gold transition-colors duration-500">
                    {item.title}
                  </h3>
                  <p className="text-sm sm:text-base text-brown-warm/70 leading-relaxed font-light">
                    {item.text}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Photos Formes Dynamiques - Responsive */}
      <section className="py-16 sm:py-24 md:py-32 px-4 sm:px-6 md:px-8 bg-champagne relative overflow-hidden">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 sm:gap-16 md:gap-24 items-center">
            {/* Photo Forme Organique */}
            <div className="relative group order-2 md:order-1 max-w-sm mx-auto md:max-w-none">
              {/* Glow animé */}
              <div className="absolute -inset-8 sm:-inset-12 bg-gradient-to-br from-gold/30 to-transparent rounded-full blur-2xl md:blur-3xl group-hover:blur-2xl transition-all duration-700 animate-pulse-slow" />
              
              <div className="relative overflow-hidden rounded-full shadow-2xl transform group-hover:scale-110 group-hover:rotate-6 transition-all duration-700 border-4 sm:border-[6px] border-gold/60 group-hover:border-gold aspect-square">
                <img
                  src="https://gillesdelieuze.com/wp-content/uploads/2024/03/IMG_0013_www.vincentphotographie.com_-650x650.jpg"
                  alt="Gilles Delieuze"
                  className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-1000 relative z-10"
                />
                
                {/* Overlay doré au hover */}
                <div className="absolute inset-0 bg-gradient-to-br from-gold/10 via-transparent to-yellow-500/10 opacity-0 group-hover:opacity-100 transition-opacity duration-700 z-20" />
              </div>
            </div>
            
            <div className="space-y-6 sm:space-y-8 md:space-y-10 order-1 md:order-2 animate-fade-in-up text-center md:text-left">
              <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-serif font-light text-brown-dark leading-tight transform hover:scale-105 transition-transform duration-500 drop-shadow-md px-2">
                Ce que je te propose, c'est un espace où ces voiles peuvent <span className="italic text-gold drop-shadow-lg">enfin se lever</span>.
              </h2>
              <div className="w-24 sm:w-32 h-1 bg-gradient-to-r from-gold to-transparent animate-shimmer-fast mx-auto md:mx-0" />
              <p className="text-base sm:text-lg md:text-xl text-brown-dark leading-relaxed font-semibold drop-shadow-sm px-2">
                Un espace où tu peux retrouver ton essence pure, libéré(e) de tout ce qui ne t'appartient pas.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Mon Approche - Responsive */}
      <section className="py-16 sm:py-24 md:py-32 px-4 sm:px-6 md:px-8 bg-beige-warm relative overflow-hidden">
        {/* Particules dorées subtiles */}
        <div className="absolute inset-0 overflow-hidden opacity-20 hidden sm:block">
          {[...Array(10)].map((_, i) => (
            <div
              key={`particle-${i}`}
              className="absolute w-1 h-1 rounded-full bg-gold animate-particle-float"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${i * 1.2}s`,
                animationDuration: `${10 + Math.random() * 8}s`
              }}
            />
          ))}
        </div>
        
        <div className="relative max-w-5xl mx-auto z-10">
          <div className="mb-12 sm:mb-16 md:mb-20 text-center">
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-serif font-light text-brown-warm mb-4 sm:mb-6 transform hover:scale-105 transition-transform duration-700 px-2">
              Mon <span className="italic text-gold">approche</span>
            </h2>
            <div className="w-32 sm:w-40 h-1 bg-gradient-to-r from-transparent via-gold to-transparent mx-auto animate-shimmer-fast" />
            <p className="text-lg sm:text-xl md:text-2xl text-gold font-light mt-6 sm:mt-8 px-2">
              Une reconnexion à ta pleine puissance
            </p>
          </div>

          <div className="space-y-10 sm:space-y-12 md:space-y-16 text-base sm:text-lg md:text-xl leading-relaxed font-light text-brown-warm">
            <p className="text-lg sm:text-xl md:text-2xl text-center hover:scale-105 transition-transform duration-500 px-2">
              Il ne s'agit pas de te "réparer", car <span className="text-gold italic">tu n'es pas brisé(e)</span>.
            </p>
            
            <p className="text-lg sm:text-xl md:text-2xl text-center hover:scale-105 transition-transform duration-500 px-2">
              Il ne s'agit pas d'ajouter encore plus de "faire", car <span className="text-gold italic">tu es déjà suffisant(e)</span>.
            </p>
            
            <div className="relative py-10 sm:py-12 md:py-16 my-10 sm:my-12 md:my-16 group">
              <div className="absolute inset-0 border-2 border-gold/30 group-hover:border-gold/60 transition-all duration-500 animate-border-pulse" />
              <div className="absolute -inset-3 sm:-inset-4 bg-gradient-to-r from-gold/10 via-gold/20 to-gold/10 blur-lg sm:blur-xl group-hover:blur-2xl transition-all duration-700" />
              <p className="relative text-xl sm:text-2xl md:text-3xl lg:text-4xl text-center font-light leading-tight px-6 sm:px-8 md:px-12 text-brown-warm">
                Il s'agit de <span className="text-gold italic">défaire</span>, de <span className="text-gold italic">libérer</span>, de <span className="text-gold italic">révéler</span> ce qui sommeille en toi.
              </p>
            </div>

            <div className="text-center p-6 sm:p-8 md:p-12 rounded-2xl sm:rounded-3xl border-2 border-gold/40 bg-white/50 backdrop-blur-sm transform hover:scale-105 transition-all duration-700 shadow-2xl">
              <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-brown-warm">
                Tout est déjà là. Il est temps de le reconnaître et de le laisser <span className="italic text-gold animate-glow">rayonner</span>.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Photo Cercle + Expérience - Responsive */}
      <section className="py-16 sm:py-24 md:py-32 px-4 sm:px-6 md:px-8 bg-beige-warm">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 sm:gap-16 md:gap-20 items-center">
            <div className="relative group max-w-sm mx-auto md:max-w-none">
              {/* Particules quantiques */}
              <div className="absolute -inset-8 sm:-inset-12 opacity-50 hidden sm:block">
                {[...Array(8)].map((_, i) => (
                  <div
                    key={i}
                    className="absolute w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full bg-gold animate-particle-float"
                    style={{
                      top: `${Math.sin(i * Math.PI / 4) * 50 + 50}%`,
                      left: `${Math.cos(i * Math.PI / 4) * 50 + 50}%`,
                      animationDelay: `${i * 0.3}s`,
                      animationDuration: '6s'
                    }}
                  />
                ))}
              </div>
              
              <div className="absolute -inset-6 sm:-inset-8 bg-gradient-to-br from-gold/30 to-yellow-500/25 rounded-full blur-2xl md:blur-3xl animate-pulse-slow" />
              
              {/* Anneaux orbitaux */}
              <div className="absolute -inset-3 sm:-inset-4 rounded-full border border-gold/30 animate-spin-slow hidden sm:block" />
              <div className="absolute -inset-1 sm:-inset-2 rounded-full border border-gold/40 animate-spin-reverse hidden sm:block" style={{animationDuration: '12s'}} />
              
              <div className="relative rounded-full overflow-hidden shadow-2xl border-4 sm:border-[6px] border-white group-hover:border-gold/60 transform group-hover:scale-110 group-hover:rotate-6 transition-all duration-700">
                <img
                  src="https://gillesdelieuze.com/wp-content/uploads/2024/03/IMG_9977_www.vincentphotographie.com_-1024x683.jpg"
                  alt="Gilles Delieuze"
                  className="w-full aspect-square object-cover transform group-hover:scale-110 transition-transform duration-1000"
                />
                <div className="absolute inset-0 bg-gradient-to-br from-gold/10 via-transparent to-gold/10 opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
              </div>
            </div>
            
            <div className="space-y-6 sm:space-y-8 animate-fade-in-up text-center md:text-left">
              <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-serif font-light text-brown-warm leading-tight px-2">
                Mon expérience : <span className="italic text-gold">Plus de 20 ans</span> d'accompagnement
              </h2>
              <div className="w-24 sm:w-32 h-1 bg-gradient-to-r from-gold to-transparent animate-shimmer-fast mx-auto md:mx-0" />
              
              <div className="space-y-4 sm:space-y-6 text-sm sm:text-base md:text-lg text-brown-warm/80 leading-relaxed font-light px-2">
                <p>
                  Formé aux <span className="font-semibold text-brown-dark">Mémoires Cellulaires</span>, <span className="font-semibold text-brown-dark">Soins Énergétiques</span>, <span className="font-semibold text-brown-dark">Lecture d'Âme</span>, et bien d'autres approches holistiques.
                </p>
                <p>
                  J'accompagne les êtres dans leur processus de transformation profonde, en créant un espace sécurisant où chacun peut se reconnecter à son essence véritable.
                </p>
                <p className="text-gold italic text-base sm:text-lg md:text-xl font-medium">
                  Un accompagnement qui honore ta singularité.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Formules - QUANTUM SHINE & QUANTUM POWER - Responsive */}
      <section id="formules" className="py-16 sm:py-24 md:py-32 px-4 sm:px-6 md:px-8 bg-gradient-to-b from-beige-warm to-champagne">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16 sm:mb-20 md:mb-24">
            <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-serif font-light text-brown-warm mb-4 sm:mb-6 transform hover:scale-105 transition-transform duration-700 px-2">
              LES <span className="italic text-gold">FORMULES</span>
            </h2>
            <div className="w-32 sm:w-40 h-1 bg-gradient-to-r from-transparent via-gold to-transparent mx-auto animate-shimmer-fast" />
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 sm:gap-12 md:gap-16">
            {/* Quantum Shine - Image Soleil Rayonnant - Responsive */}
            <div className="group relative transform hover:-translate-y-6 transition-all duration-700">
              <div className="absolute -inset-6 sm:-inset-8 bg-gradient-to-br from-gold/30 to-transparent rounded-3xl blur-2xl md:blur-3xl group-hover:blur-2xl transition-all duration-700 animate-pulse-slow" />
              
              <div className="relative bg-white rounded-2xl sm:rounded-3xl overflow-hidden shadow-2xl border-3 sm:border-4 border-gold/40 group-hover:border-gold transition-all duration-500 transform group-hover:scale-105">
                <div className="relative h-64 sm:h-80 md:h-96 overflow-hidden">
                  <img
                    src="https://images.unsplash.com/photo-1718701409970-f7dc52425a01?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxnb2xkZW4lMjBzdW4lMjByYXlzfGVufDB8fHx5ZWxsb3d8MTc3NTg1Nzk1M3ww&ixlib=rb-4.1.0&q=85"
                    alt="Soleil Rayonnant Quantum Shine"
                    className="w-full h-full object-cover object-center transform group-hover:scale-110 transition-all duration-1000"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                  
                  {/* Cercles concentriques DORÉS - Adaptés mobile */}
                  <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex items-center justify-center">
                    {/* Noyau central brillant */}
                    <div className="absolute w-8 h-8 sm:w-12 sm:h-12 rounded-full bg-gradient-to-br from-white via-gold to-yellow-400 animate-pulse-slow shadow-2xl z-20">
                      <div className="absolute inset-0 rounded-full bg-gradient-to-br from-white/60 to-transparent animate-spin-slow" />
                    </div>
                    
                    {/* Cercles concentriques animés - Masqués sur mobile */}
                    <div className="hidden sm:block absolute w-20 h-20 rounded-full border-2 border-gold animate-ping opacity-75" style={{animationDuration: '3s'}} />
                    <div className="hidden sm:block absolute w-32 h-32 rounded-full border-2 border-gold/80 animate-ping opacity-60" style={{animationDuration: '4s', animationDelay: '0.5s'}} />
                    <div className="hidden md:block absolute w-44 h-44 rounded-full border-2 border-gold/60 animate-ping opacity-50" style={{animationDuration: '5s', animationDelay: '1s'}} />
                    <div className="hidden md:block absolute w-56 h-56 rounded-full border border-gold/40 animate-ping opacity-40" style={{animationDuration: '6s', animationDelay: '1.5s'}} />
                    
                    {/* Cercles rotatifs dorés - Masqués sur mobile */}
                    <div className="hidden sm:block absolute w-24 h-24 rounded-full border-2 border-gold/70 animate-spin-slow" />
                    <div className="hidden md:block absolute w-36 h-36 rounded-full border border-gold/50 animate-spin-reverse" style={{animationDuration: '15s'}} />
                    
                    {/* Rayons lumineux dorés - Réduits sur mobile */}
                    <div className="absolute inset-0 w-32 h-32 sm:w-48 sm:h-48 md:w-64 md:h-64 -ml-16 -mt-16 sm:-ml-24 sm:-mt-24 md:-ml-32 md:-mt-32">
                      {[...Array(8)].map((_, i) => (
                        <div
                          key={i}
                          className="absolute top-1/2 left-1/2 w-0.5 sm:w-1 h-10 sm:h-12 md:h-16 bg-gradient-to-t from-gold via-gold/60 to-transparent origin-bottom animate-pulse-slow"
                          style={{
                            transform: `translate(-50%, -100%) rotate(${i * 45}deg)`,
                            animationDelay: `${i * 0.2}s`
                          }}
                        />
                      ))}
                    </div>
                  </div>
                </div>
                
                <div className="p-6 sm:p-10 md:p-12">
                  <h3 className="text-2xl sm:text-3xl md:text-4xl font-serif font-light mb-2 text-brown-warm transform group-hover:scale-105 transition-transform duration-500">
                    QUANTUM SHINE
                  </h3>
                  <p className="text-lg sm:text-xl text-gold mb-6 sm:mb-8 md:mb-10 font-light italic">
                    Se reconnecter à sa vérité
                  </p>
                  
                  <div className="mb-6 sm:mb-8 md:mb-10 pb-6 sm:pb-8 md:pb-10 border-b-2 border-brown-warm/20">
                    <p className="text-sm sm:text-base text-brown-warm mb-2 font-light">6 séances individuelles</p>
                    <p className="text-xs sm:text-sm text-brown-warm/60">1 par mois, sur 6 mois</p>
                  </div>

                  <h4 className="text-base sm:text-lg text-brown-warm mb-6 sm:mb-8 leading-tight font-light">
                    Révéler sa lumière intérieure & retrouver une pleine liberté d'Être
                  </h4>

                  <div className="space-y-3 sm:space-y-4 mb-8 sm:mb-10 md:mb-12 text-xs sm:text-sm text-brown-warm/70 font-light">
                    <p>Déblocage des mémoires et des schémas répétitifs</p>
                    <p>Harmonisation énergétique & réalignement vibratoire</p>
                    <p>Activation de ta présence magnétique</p>
                  </div>

                  <div className="mb-6 sm:mb-8 md:mb-10">
                    <p className="text-xs text-brown-warm/50 mb-2 tracking-wider uppercase">À partir de</p>
                    <p className="text-4xl sm:text-5xl md:text-6xl font-light text-gold transform group-hover:scale-110 transition-transform duration-500">
                      8€<span className="text-lg sm:text-xl md:text-2xl text-brown-warm/60">/jour</span>
                    </p>
                  </div>

                  <a 
                    href="https://gillesdelieuze.com/shine-bright/" 
                    className="w-full inline-block bg-gradient-to-r from-brown-warm via-brown-dark to-brown-warm bg-size-200 hover:shadow-2xl text-champagne py-5 sm:py-6 md:py-7 rounded-full text-sm sm:text-base tracking-[0.15em] uppercase font-semibold border-2 border-champagne/20 transform hover:scale-105 transition-all duration-500 text-center cursor-pointer"
                  >
                    Je découvre en détail
                  </a>
                </div>
              </div>
            </div>

            {/* Quantum Power - Image ADN/Atomes Quantiques - Responsive */}
            <div className="group relative transform hover:-translate-y-6 transition-all duration-700">
              <div className="absolute -inset-6 sm:-inset-8 bg-gradient-to-br from-gold/30 to-transparent rounded-3xl blur-2xl md:blur-3xl group-hover:blur-2xl transition-all duration-700 animate-pulse-slow animation-delay-500" />
              
              <div className="relative bg-white rounded-2xl sm:rounded-3xl overflow-hidden shadow-2xl border-3 sm:border-4 border-gold/40 group-hover:border-gold transition-all duration-500 transform group-hover:scale-105">
                <div className="relative h-64 sm:h-80 md:h-96 overflow-hidden bg-gradient-to-br from-amber-50 to-yellow-50">
                  <img
                    src="https://images.pexels.com/photos/12214773/pexels-photo-12214773.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                    alt="Structure Quantique ADN Atomes"
                    className="w-full h-full object-cover transform group-hover:scale-110 group-hover:-rotate-3 transition-all duration-1000"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                  
                  {/* Atomes orbitaux animés - Adaptés mobile */}
                  <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-32 h-32 sm:w-40 sm:h-40 md:w-48 md:h-48">
                    {/* Noyau central pulsant */}
                    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-6 h-6 sm:w-8 sm:h-8 md:w-10 md:h-10 rounded-full bg-gradient-to-br from-gold via-yellow-400 to-gold shadow-2xl animate-glow">
                      <div className="absolute inset-0 rounded-full bg-gradient-to-br from-white/50 to-transparent animate-spin-slow" />
                    </div>
                    
                    {/* Orbites multiples - Simplifiées sur mobile */}
                    <div className="absolute inset-0 rounded-full border-2 border-gold/50 animate-spin-slow" />
                    <div className="hidden sm:block absolute inset-3 rounded-full border-2 border-gold/40 animate-spin-reverse" />
                    <div className="hidden md:block absolute inset-6 rounded-full border border-gold/30 animate-spin-slow" style={{animationDuration: '10s'}} />
                    
                    {/* Électrons sur orbites - Réduits sur mobile */}
                    <div className="absolute top-0 left-1/2 w-3 h-3 sm:w-4 sm:h-4 -ml-1.5 sm:-ml-2 rounded-full bg-gradient-to-br from-gold to-yellow-500 shadow-lg animate-spin-slow" />
                    <div className="absolute bottom-0 left-1/2 w-3 h-3 sm:w-4 sm:h-4 -ml-1.5 sm:-ml-2 rounded-full bg-gradient-to-br from-gold to-yellow-500 shadow-lg animate-spin-slow" />
                    <div className="hidden sm:block absolute top-1/2 right-0 w-4 h-4 -mt-2 rounded-full bg-gradient-to-br from-gold to-yellow-500 shadow-lg animate-spin-reverse" />
                    <div className="hidden sm:block absolute top-1/2 left-0 w-4 h-4 -mt-2 rounded-full bg-gradient-to-br from-gold to-yellow-500 shadow-lg animate-spin-reverse" />
                  </div>
                </div>
                
                <div className="p-6 sm:p-10 md:p-12">
                  <h3 className="text-2xl sm:text-3xl md:text-4xl font-serif font-light mb-2 text-brown-warm transform group-hover:scale-105 transition-transform duration-500">
                    QUANTUM POWER
                  </h3>
                  <p className="text-lg sm:text-xl text-gold mb-6 sm:mb-8 md:mb-10 font-light italic">
                    & Quantum Leadership
                  </p>
                  
                  <div className="mb-6 sm:mb-8 md:mb-10 pb-6 sm:pb-8 md:pb-10 border-b-2 border-brown-warm/20">
                    <p className="text-sm sm:text-base text-brown-warm mb-2 font-light">5 à 10 séances individuelles</p>
                    <p className="text-xs sm:text-sm text-brown-warm/60">sur 6 à 12 mois</p>
                  </div>

                  <h4 className="text-base sm:text-lg text-brown-warm mb-6 sm:mb-8 leading-tight font-light">
                    Expansion, magnétisme et leadership conscient
                  </h4>

                  <div className="space-y-3 sm:space-y-4 mb-8 sm:mb-10 md:mb-12 text-xs sm:text-sm text-brown-warm/70 font-light">
                    <p>Déblocage des résistances et alignement énergétique</p>
                    <p>Reconnexion à ton magnétisme naturel</p>
                    <p>Optimisation de ton message et positionnement vibratoire</p>
                    <p>Travail énergétique avancé</p>
                    <p>Posture, visibilité & leadership magnétique</p>
                  </div>

                  <div className="mb-6 sm:mb-8 md:mb-10">
                    <p className="text-xs text-brown-warm/50 mb-2 tracking-wider uppercase">À partir de</p>
                    <p className="text-4xl sm:text-5xl md:text-6xl font-light text-gold transform group-hover:scale-110 transition-transform duration-500">
                      500€<span className="text-lg sm:text-xl md:text-2xl text-brown-warm/60">/mois</span>
                    </p>
                  </div>

                  <a 
                    href="https://gillesdelieuze.com/platinum-level-up/" 
                    className="w-full inline-block bg-gradient-to-r from-brown-warm via-brown-dark to-brown-warm bg-size-200 hover:shadow-2xl text-champagne py-5 sm:py-6 md:py-7 rounded-full text-sm sm:text-base tracking-[0.15em] uppercase font-semibold border-2 border-champagne/20 transform hover:scale-105 transition-all duration-500 text-center cursor-pointer"
                  >
                    Je découvre en détail
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section Méthode testée et approuvée - Responsive */}
      <section className="py-16 sm:py-24 md:py-32 px-4 sm:px-6 md:px-8 bg-brown-dark text-champagne relative overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_rgba(201,169,97,0.1)_0%,_transparent_70%)] animate-pulse-slow" />
        
        <div className="max-w-6xl mx-auto relative z-10">
          <div className="text-center mb-12 sm:mb-16 md:mb-20">
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-light mb-4 sm:mb-6 px-2">
              Méthode <span className="italic text-gold">testée et approuvée</span>
            </h2>
            <div className="w-32 sm:w-40 h-1 bg-gradient-to-r from-transparent via-gold to-transparent mx-auto animate-shimmer-fast" />
            <p className="text-base sm:text-lg md:text-xl text-champagne/80 mt-6 sm:mt-8 px-2">
              Des transformations réelles, des témoignages authentiques
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 md:gap-10">
            {[
              {
                name: "Sophie L.",
                text: "« Gilles a une capacité extraordinaire à voir ce qui se cache sous la surface. En quelques séances, j'ai libéré des mémoires que je portais depuis toujours. Je me sens enfin alignée et libre. »"
              },
              {
                name: "Marc D.",
                text: "« Un accompagnement d'une profondeur rare. Gilles crée un espace de confiance totale où tout peut émerger. Ma vie a changé de cap grâce à ce travail. »"
              },
              {
                name: "Claire B.",
                text: "« J'ai retrouvé ma lumière intérieure. Le travail avec Gilles m'a permis de me reconnecter à mon essence et de rayonner pleinement. Une expérience bouleversante. »"
              },
              {
                name: "Thomas R.",
                text: "« Des séances qui vont bien au-delà de ce que j'imaginais. Gilles m'a aidé à dissoudre des blocages profonds et à incarner ma pleine puissance. Infin iment reconnaissant. »"
              }
            ].map((testimonial, i) => (
              <div 
                key={i} 
                className="group relative p-6 sm:p-8 bg-beige-warm/10 backdrop-blur-sm rounded-2xl sm:rounded-3xl border border-gold/20 hover:border-gold/60 transform hover:scale-105 transition-all duration-500 shadow-lg hover:shadow-2xl"
              >
                <div className="absolute -inset-3 sm:-inset-4 bg-gradient-to-br from-gold/10 to-transparent rounded-3xl blur-xl group-hover:blur-2xl transition-all duration-700 opacity-0 group-hover:opacity-100" />
                
                <div className="relative">
                  <p className="text-sm sm:text-base md:text-lg text-champagne/90 leading-relaxed mb-4 sm:mb-6 italic">
                    {testimonial.text}
                  </p>
                  <p className="text-gold font-semibold text-sm sm:text-base">— {testimonial.name}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Final - Responsive */}
      <section className="py-16 sm:py-24 md:py-32 px-4 sm:px-6 md:px-8 bg-gradient-to-br from-beige-warm via-champagne to-beige-warm relative overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_30%_50%,_rgba(201,169,97,0.2)_0%,_transparent_50%)]" />
          <div className="absolute top-0 right-0 w-full h-full bg-[radial-gradient(circle_at_70%_50%,_rgba(201,169,97,0.2)_0%,_transparent_50%)]" />
        </div>
        
        <div className="max-w-4xl mx-auto text-center relative z-10">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-light text-brown-warm mb-6 sm:mb-8 leading-tight px-2">
            Prêt(e) à <span className="italic text-gold">révéler ta pleine lumière</span> ?
          </h2>
          <div className="w-32 sm:w-40 h-1 bg-gradient-to-r from-transparent via-gold to-transparent mx-auto mb-8 sm:mb-12 animate-shimmer-fast" />
          
          <p className="text-lg sm:text-xl md:text-2xl text-brown-warm/80 mb-8 sm:mb-10 md:mb-12 leading-relaxed px-2">
            Le moment est venu de te reconnecter à ton essence et de laisser rayonner ta puissance intérieure.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center">
            <a 
              href="https://gillesdelieuze.com/contact/" 
              className="group bg-brown-dark hover:bg-brown-warm text-champagne px-10 sm:px-14 py-5 sm:py-7 rounded-full text-sm sm:text-base tracking-[0.15em] uppercase font-bold transform hover:scale-110 transition-all duration-500 border-2 border-gold shadow-2xl inline-block"
            >
              <span className="group-hover:tracking-[0.2em] transition-all duration-300">Réserver une séance</span>
            </a>
            <a 
              href="https://gillesdelieuze.com/a-propos/" 
              className="border-3 border-brown-dark bg-white/90 text-brown-dark hover:bg-gold hover:text-white hover:border-gold hover:shadow-2xl px-10 sm:px-14 py-5 sm:py-7 rounded-full text-sm sm:text-base tracking-[0.15em] uppercase font-bold transform hover:scale-110 transition-all duration-500 shadow-lg inline-block"
            >
              En savoir plus
            </a>
          </div>
        </div>
      </section>

      {/* Footer - Responsive */}
      <footer className="bg-brown-dark text-champagne/70 py-10 sm:py-12 md:py-16 px-4 sm:px-6 md:px-8 relative overflow-hidden">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 md:gap-12 mb-8 sm:mb-10 md:mb-12">
            <div>
              <h3 className="text-gold font-semibold mb-4 sm:mb-6 text-sm sm:text-base uppercase tracking-wider">Navigation</h3>
              <ul className="space-y-2 sm:space-y-3 text-xs sm:text-sm">
                <li><a href="https://gillesdelieuze.com/" className="hover:text-gold transition-colors">Accueil</a></li>
                <li><a href="https://gillesdelieuze.com/formations/" className="hover:text-gold transition-colors">Formations</a></li>
                <li><a href="https://gillesdelieuze.com/voyages-2/" className="hover:text-gold transition-colors">Voyages</a></li>
                <li><a href="https://gillesdelieuze.com/accompagnements-11/" className="hover:text-gold transition-colors">Accompagnements</a></li>
                <li><a href="https://gillesdelieuze.com/a-propos/" className="hover:text-gold transition-colors">À propos</a></li>
              </ul>
            </div>
            
            <div>
              <h3 className="text-gold font-semibold mb-4 sm:mb-6 text-sm sm:text-base uppercase tracking-wider">Contact</h3>
              <ul className="space-y-2 sm:space-y-3 text-xs sm:text-sm">
                <li><a href="https://gillesdelieuze.com/contact/" className="hover:text-gold transition-colors">Me contacter</a></li>
                <li><a href="mailto:contact@gillesdelieuze.com" className="hover:text-gold transition-colors">Email</a></li>
              </ul>
            </div>
            
            <div>
              <h3 className="text-gold font-semibold mb-4 sm:mb-6 text-sm sm:text-base uppercase tracking-wider">Suivez-moi</h3>
              <ul className="space-y-2 sm:space-y-3 text-xs sm:text-sm">
                <li><a href="https://www.facebook.com/gillesdelieuze" className="hover:text-gold transition-colors">Facebook</a></li>
                <li><a href="https://www.instagram.com/gillesdelieuze" className="hover:text-gold transition-colors">Instagram</a></li>
              </ul>
            </div>
            
            <div>
              <h3 className="text-gold font-semibold mb-4 sm:mb-6 text-sm sm:text-base uppercase tracking-wider">Légal</h3>
              <ul className="space-y-2 sm:space-y-3 text-xs sm:text-sm">
                <li><a href="https://gillesdelieuze.com/mentions-legales/" className="hover:text-gold transition-colors">Mentions légales</a></li>
                <li><a href="https://gillesdelieuze.com/politique-de-confidentialite/" className="hover:text-gold transition-colors">Confidentialité</a></li>
              </ul>
            </div>
          </div>
          
          <div className="border-t border-gold/20 pt-6 sm:pt-8 text-center text-xs sm:text-sm">
            <p>© 2025 Gilles Delieuze. Tous droits réservés.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Accompagnements;
